import { TemplateApiService } from '@api/template/template.api.service';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { BaseRequestParams } from 'types/RequestParams';
import { ActionResponse, ChargingStationTemplateDataResult } from '../../types/DataResult';
import { ChargingStationTemplate } from '../../types/ChargingStationTemplate';

@Injectable()
export class TemplateRepositoryService {
  private readonly templateApi = inject(TemplateApiService);

  public getChargerTemplates(params: BaseRequestParams = {}): Observable<ChargingStationTemplateDataResult> {
    return this.templateApi.getChargerTemplates(params);
  }

  public getChargerTemplate(templateId: string): Observable<ChargingStationTemplate> {
    return this.templateApi.getChargerTemplate(templateId);
  }

  public createChargerTemplate(template: ChargingStationTemplate): Observable<ChargingStationTemplate> {
    return this.templateApi.createChargerTemplate(template);
  }

  public updateChargerTemplate(template: ChargingStationTemplate): Observable<ChargingStationTemplate> {
    return this.templateApi.updateChargerTemplate(template.id, template);
  }

  public deleteChargerTemplate(templateId: string): Observable<ActionResponse> {
    return this.templateApi.deleteChargerTemplate(templateId);
  }
}
